/**
 * Size defines and processes the size(width/height) of the objects
 */
export class Size {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
    // /**   @private  */
    // public isEmpty(): boolean {
    //     return this.height === 0 && this.width === 0;
    // }
    /**   @private  */
    clone() {
        return new Size(this.width, this.height);
    }
}
